import { format, formatDistanceToNow } from 'date-fns';

export function safeFormatDate(dateString: string | null | undefined, formatStr: string = 'dd MMM yyyy, HH:mm'): string {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    return format(date, formatStr);
  } catch (error) {
    console.error('Error formatting date:', error);
    return '-';
  }
}

export function safeFormatDistance(dateString: string | null | undefined): string {
  if (!dateString) return 'Just now';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Just now';
    return formatDistanceToNow(date, { addSuffix: true });
  } catch (error) {
    console.error('Error formatting date distance:', error);
    return 'Just now';
  }
}

export function safeFormatTime(dateString: string | null | undefined): string {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    return date.toLocaleTimeString();
  } catch (error) {
    console.error('Error formatting time:', error);
    return '-';
  }
}

export function safeFormatDateOnly(dateString: string | null | undefined): string {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    return date.toLocaleDateString();
  } catch (error) {
    console.error('Error formatting date only:', error);
    return '-';
  }
}

export function calculateDuration(startDate: string | null | undefined, endDate: string | null | undefined): string {
  if (!startDate || !endDate) return 'N/A';
  try {
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (isNaN(start.getTime()) || isNaN(end.getTime())) return 'N/A';
    const duration = Math.round((end.getTime() - start.getTime()) / (1000 * 60));
    return `${duration} mins`;
  } catch (error) {
    console.error('Error calculating duration:', error);
    return 'N/A';
  }
}

export function formatMedicationDuration(duration: string | number | null | undefined): string {
  if (!duration) return '-';
  
  const durationNum = typeof duration === 'string' ? parseInt(duration) : duration;
  
  if (isNaN(durationNum) || durationNum < 1) return '-';
  
  return `${durationNum} days`;
}

export function safeFormatDateTime(dateString: string | null | undefined): string {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    return format(date, 'dd MMM yyyy, HH:mm');
  } catch (error) {
    console.error('Error formatting date time:', error);
    return '-';
  }
} 